import { motion } from "framer-motion";
import React from "react";

const FadeIn = ({
  direction = "top",
  children,
  duration = 0.8,
  className = "",
  ...otherProps
}) => {
  const variants = {
    top: {
      hidden: { opacity: 0, y: -50 },
      visible: { opacity: 1, y: 0 },
    },
    bottom: {
      hidden: { opacity: 0, y: 50 },
      visible: { opacity: 1, y: 0 },
    },
    left: {
      hidden: { opacity: 0, x: -50 },
      visible: { opacity: 1, x: 0 },
    },
    right: {
      hidden: { opacity: 0, x: 50 },
      visible: { opacity: 1, x: 0 },
    },
    leftBottom: {
      hidden: { opacity: 0, x: -50, y: 50 },
      visible: { opacity: 1, x: 0, y: 0 },
    },
  };
  return (
    <motion.div
      variants={variants[direction]}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration: duration, ease: "easeOut" }}
      className={className}
      {...otherProps}
    >
      {children}
    </motion.div>
  );
};

export default FadeIn;
